import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "./App.css";
import Landing from "./pages/Landing";
import PrescriptionForm from "./pages/PrescriptionForm";
import PrescriptionReveal from "./pages/PrescriptionReveal";
import Resume from "./pages/Resume";
import Unsubscribe from "./pages/Unsubscribe";
import ThankYou from "./pages/ThankYou";
import DeliveryAddress from "./pages/DeliveryAddress";
import OrderConfirmation from "./pages/OrderConfirmation";
import VedicCalendar from "./pages/admin/VedicCalendar";
import PersonalYearMeanings from "./pages/admin/PersonalYearMeanings";
import MyPrescriptionLogin from "./pages/MyPrescriptionLogin";
import MyPrescriptionDashboard from "./pages/MyPrescriptionDashboard";
import AdminLogin from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import OrdersList from "./pages/admin/OrdersList";
import NewOrder from "./pages/admin/NewOrder";
import OrderDetail from "./pages/admin/OrderDetail";
import Inventory from "./pages/admin/Inventory";
import Abandoned from "./pages/admin/Abandoned";
import { inventoryApi } from "./lib/api";
import { ALL_CRYSTALS } from "./lib/crystalPrescription";

function RequireAdmin({ children }) {
  const authed = localStorage.getItem("ph-admin") === "ok";
  if (!authed) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  useEffect(() => {
    // Seed inventory on first load if empty
    inventoryApi
      .seed(ALL_CRYSTALS.map((c) => ({ crystalName: c, stock: 100, reorderLevel: 20 })))
      .catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/prescription" element={<PrescriptionForm />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/reveal/:id" element={<PrescriptionReveal />} />
          <Route path="/order/:id/address" element={<DeliveryAddress />} />
          <Route path="/order/:id/confirmation" element={<OrderConfirmation />} />
          <Route path="/my-prescription" element={<MyPrescriptionLogin />} />
          <Route path="/my-prescription/dashboard" element={<MyPrescriptionDashboard />} />
          <Route path="/thank-you/:id" element={<ThankYou />} />

          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/back-office" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<RequireAdmin><Dashboard /></RequireAdmin>} />
          <Route path="/admin/orders" element={<RequireAdmin><OrdersList /></RequireAdmin>} />
          <Route path="/admin/abandoned" element={<RequireAdmin><Abandoned /></RequireAdmin>} />
          <Route path="/admin/new-order" element={<RequireAdmin><NewOrder /></RequireAdmin>} />
          <Route path="/admin/orders/:id" element={<RequireAdmin><OrderDetail /></RequireAdmin>} />
          <Route path="/admin/inventory" element={<RequireAdmin><Inventory /></RequireAdmin>} />
          <Route path="/admin/vedic-calendar" element={<RequireAdmin><VedicCalendar /></RequireAdmin>} />
          <Route path="/admin/personal-year-meanings" element={<RequireAdmin><PersonalYearMeanings /></RequireAdmin>} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
